import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { CompanyProvider } from './contexts/CompanyContext';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import TrialLockedRoute from './components/TrialLockedRoute';
import PlatformAdminRoute from './components/PlatformAdminRoute';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import ClientsPage from './pages/Clients';
import ProjectsPage from './pages/Projects';
import InvoicesPage from './pages/Invoices';
import PaymentsPage from './pages/Payments';
import ReportsPage from './pages/Reports';
import CompanySelect from './pages/CompanySelect';
import TeamManagement from './pages/TeamManagement';
import PaymentSchedules from './pages/PaymentSchedules';
import Expenses from './pages/Expenses';
import Billing from './pages/Billing';
import Connectors from './pages/Connectors';
import AdminCompanies from './pages/AdminCompanies';
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <CompanyProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/companies" element={
                <PrivateRoute>
                  <CompanySelect />
                </PrivateRoute>
              } />
              <Route
                path="/*"
                element={
                  <PrivateRoute>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/clients" element={<TrialLockedRoute><ClientsPage /></TrialLockedRoute>} />
                        <Route path="/projects" element={<TrialLockedRoute><ProjectsPage /></TrialLockedRoute>} />
                        <Route path="/invoices" element={<TrialLockedRoute><InvoicesPage /></TrialLockedRoute>} />
                        <Route path="/payments" element={<TrialLockedRoute><PaymentsPage /></TrialLockedRoute>} />
                        <Route path="/payment-schedules" element={<TrialLockedRoute><PaymentSchedules /></TrialLockedRoute>} />
                        <Route path="/expenses" element={<TrialLockedRoute><Expenses /></TrialLockedRoute>} />
                        <Route path="/reports" element={<ReportsPage />} />
                        <Route path="/team" element={<TrialLockedRoute><TeamManagement /></TrialLockedRoute>} />
                        <Route path="/billing" element={<Billing />} />
                        <Route path="/connectors" element={<TrialLockedRoute><Connectors /></TrialLockedRoute>} />
                        <Route path="/admin/companies" element={<PlatformAdminRoute><AdminCompanies /></PlatformAdminRoute>} />
                      </Routes>
                    </Layout>
                  </PrivateRoute>
                }
              />
            </Routes>
            <Toaster position="top-right" richColors />
          </div>
        </Router>
      </CompanyProvider>
    </QueryClientProvider>
  );
}

export default App;
